// Hook: useAnonSupportSidebarSync
// Sincroniza el pseudo-DM anónimo en localStorage y fuerza update en la sidebar
// para que el usuario (logueado o no) siempre vea el último estado del chat anónimo.

import { useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';
import { clearAnonymousSupportConversationOnly, getDefaultSupportStoreId, setAnonymousSupportConversation } from '@/lib/anonymousSupportChat';

export function useAnonSupportSidebarSync(anonymousSessionId?: string, supportStoreId?: string) {
  useEffect(() => {
    if (!anonymousSessionId) return;
    let mounted = true;
    const effectiveStoreId = supportStoreId || getDefaultSupportStoreId();

    const fetchAndUpdate = async () => {
      const { data, error } = await supabase
        .from('anonymous_support_chats')
        .select('*')
        .eq('anonymous_session_id', anonymousSessionId)
        .order('created_at', { ascending: true });
      if (error) return;
      if (!mounted) return;
      if (!data || data.length === 0) {
        clearAnonymousSupportConversationOnly(effectiveStoreId);
        return;
      }
      const lastMsg = data[data.length - 1];
      const unreadCount = data.filter(m => m.sender_type === 'support_admin' && !m.read).length;
      setAnonymousSupportConversation(effectiveStoreId, {
        sessionId: anonymousSessionId,
        lastMessage: lastMsg.message,
        lastMessageAt: lastMsg.created_at,
        unreadCount,
      });
    };

    fetchAndUpdate();
    const interval = setInterval(fetchAndUpdate, 2000);
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [anonymousSessionId, supportStoreId]);
}
